import { Link } from "react-router-dom";
import Header from "@/components/Header";

// SPA soft-404 page. The hosting layer returns HTTP 200 for client-side routes,
// so this page relies on a `noindex` robots directive (set by SeoManager for
// unknown paths) plus clear "not found" content to keep it out of search.
export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FAF8F4]">
      <Header />
      <div className="max-w-xl mx-auto text-center px-6 py-28" data-testid="not-found-page">
        <p className="text-6xl font-bold text-[#20493B]" style={{ fontFamily: "Outfit" }}>404</p>
        <h1 className="text-2xl font-bold text-[#2D2926] mt-3" style={{ fontFamily: "Outfit" }}>
          Page not found
        </h1>
        <p className="text-[#5C554E] mt-2">
          The page you&apos;re looking for doesn&apos;t exist or may have moved.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <Link to="/" className="btn-lime px-6 py-3 text-sm" data-testid="not-found-home">Back to home</Link>
          <Link to="/search" className="px-6 py-3 text-sm font-semibold text-[#245544] underline underline-offset-2" data-testid="not-found-browse">
            Browse pros
          </Link>
        </div>
      </div>
    </div>
  );
}
